// @ts-nocheck
import React, { useState, useRef } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Naskor } from '../../../../../../js/components/naskor';
import * as InterfaceCollection from '../../InterfaceCollection';
import type { NaskorVtsBasketProductAttributePosition } from '../../InterfaceCollection';
import { formatDate } from '../../../../../Helper/formatter';

export default function BrandRow({
  basket,
  brandPosition: initialBrandPosition,
}: {
  basket: InterfaceCollection.VtsBasket;
  brandPosition: InterfaceCollection.NaskorVtsBasketBrandPosition;
}) {
  const [brandPosition, setBrandPosition] = useState(initialBrandPosition);
  const [productSizeRowsVisible, setProductSizeRowsVisible] = useState(false);
  const visibilityRef = useRef<HTMLTableRowElement | null>(null);

  const handleRowClick = () => {
    if (visibilityRef.current) {
      if (visibilityRef.current.style.display === 'none') {
        visibilityRef.current.style.display = '';
      } else {
        visibilityRef.current.style.display = 'none';
      }
    }

    setProductSizeRowsVisible((prev) => !prev);

    if (!brandPosition.product_size_positions) {
      loadBrandPositionFromServer();
    }
  };

  const loadBrandPositionFromServer = () => {
    const route =
      '/api/onlineshop/vts-release-basket/brand-position/' +
      brandPosition.brand.id;
    Naskor.fetchJson(route).then((response) => {
      setBrandPosition(response);
    });
  };

  const getHtml_showProductRowsButton = () => {
    let show;
    if (productSizeRowsVisible) {
      if (brandPosition.product_size_positions) {
        show = (
          <td className="basket-table__details">
            <IoIosArrowUp />
            Hide Details
          </td>
        );
      } else {
        show = (
          <td className="basket-table__details">
            <span className="basket-spinner" />
            Show Details
          </td>
        );
      }
    } else {
      show = (
        <td className="basket-table__details">
          <IoIosArrowDown />
          Show Details
        </td>
      );
    }
    return show;
  };

  return (
    <React.Fragment>
      <tr onClick={handleRowClick} key={'row-data-' + brandPosition.brand.id}>
        <td className="basket-table__brand">{brandPosition.brand.name}</td>
        {getHtml_showProductRowsButton()}
        <td className="basket-table__quantity">
          {brandPosition.total_quantity}
        </td>
        <td className="basket-table__total">
          {Naskor.formatPrice(brandPosition.total_price_excl_vat)}
        </td>
      </tr>
      {brandPosition.product_size_positions && (
        <tr ref={visibilityRef} key={'row-expanded-' + brandPosition.brand.id}>
          <td colSpan={4}>
            <div className="basket-table__details">
              {brandPosition.product_size_positions.map((products_size) => {
                return products_size.product_attribute_positions.map(
                  (productAttributePosition) => {
                    return (
                      <div
                        className="row"
                        key={productAttributePosition.product_attribute_id}
                      >
                        <div className="col-sm-1">
                          <img src={products_size.image_uri} alt="" />
                        </div>
                        <div className="col-sm-2">
                          <div>
                            <p>
                              <strong>{brandPosition.brand.name}</strong>
                            </p>
                            <p>{products_size.product_size_name}</p>
                            <p>
                              <strong className="promo-text">
                                {products_size.promo_text}
                              </strong>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div>
                            <p>
                              <strong>Flavour</strong>{' '}
                              {productAttributePosition.product_attribute_name}
                            </p>
                            <p>
                              <strong>Price </strong>
                              <s>
                                {Naskor.formatPrice(
                                  productAttributePosition.single_price_regular_excl_vat
                                )}
                              </s>
                              /
                              <span className="red">
                                {Naskor.formatPrice(
                                  productAttributePosition.single_price_excl_vat
                                )}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div>
                            <p>
                              <strong>Estimated expire date</strong>
                            </p>
                            <p>
                              {productAttributePosition.stock_per_expire_date &&
                              productAttributePosition.stock_per_expire_date
                                .length > 0 ? (
                                productAttributePosition.stock_per_expire_date.map(
                                  (expire_date_quantity, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span className="expdate">
                                          {expire_date_quantity.quantity}x{' '}
                                          {formatDate(
                                            expire_date_quantity.expire_date
                                          )}
                                        </span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  }
                                )
                              ) : (
                                <div>No expire date</div>
                              )}
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-sm-1 text-right"
                          title={
                            productAttributePosition.quantity_on_stock <
                            productAttributePosition.quantity
                              ? 'Requested: ' +
                                productAttributePosition.quantity
                              : ''
                          }
                        >
                          {productAttributePosition.quantity_on_stock}
                        </div>
                        <div className="col-sm-2">
                          <div className="basket-line-total">
                            <p>
                              <s>
                                {Naskor.formatPrice(
                                  productAttributePosition.single_price_regular_excl_vat *
                                    parseInt(productAttributePosition.quantity)
                                )}
                              </s>
                            </p>
                            <p className="red">
                              {Naskor.formatPrice(
                                productAttributePosition.single_price_excl_vat *
                                  parseInt(productAttributePosition.quantity)
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  }
                );
              })}
            </div>
          </td>
        </tr>
      )}
    </React.Fragment>
  );
}
